/**
 * The org the console is acting in (JSS#1182), so a page can name it in a link.
 *
 * The BFF decides the acting org (`X-Org-Override`, `requireOrgSelection`)
 * and reports it on /api/auth/me as `actingOrgId` (#1149, #1174); this reads
 * that rather than re-deriving it, so a pick the BFF rejected (#1171) is not
 * acted in here either. No acting org (a superuser in the all-orgs view, a
 * member of several orgs with no pick) is undefined.
 */
import { useQuery } from '@tanstack/react-query';
import { meApi } from '@/api/client';
import { useAuth } from '@/contexts/AuthContext';

/** The switcher's list (Header.tsx, same query key) and the acting org within it. */
export function useActingOrg(enabled = true) {
  const { user, isSuperUser, meStatus } = useAuth();
  // A lambda, so a test that mocks only part of the API client fails the
  // query (tolerated) instead of the render.
  const organizations = useQuery({
    queryKey: ['my-organizations'],
    queryFn: () => meApi.organizations(),
    enabled,
    staleTime: 60_000,
  });
  return {
    superuser: isSuperUser(),
    organizations,
    actingOrgId: user?.actingOrgId ?? undefined,
    /** /api/auth/me has not answered yet, so actingOrgId is not known. */
    actingOrgPending: meStatus === 'pending',
  };
}
